var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionUserList", {
        attrs: {
          xs12: "",
          userList: _vm.userList,
          isLoading: _vm.isLoading,
          shouldShowSearch: true,
        },
        on: {
          onEditUserClicked: (val) => [
            (_vm.userToEdit = val.userToEdit),
            (_vm.showDialogFormUserEdit = true),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormUserEdit", {
        attrs: {
          showDialog: _vm.showDialogFormUserEdit,
          userToEdit: _vm.userToEdit,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormUserEdit = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormUserEditSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }